import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrending1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTrending1"><Path fillRule="evenodd" clipRule="evenodd" d="M13.1734 1.20203L18.2148 17.3345L20.5528 12.6583L22.3417 13.5528L17.7853 22.6655L12.8267 6.79791L8.12235 17.1475L4.95554 11.8695L3.27738 14.3867L1.61328 13.2773L5.04452 8.13046L7.87772 12.8525L13.1734 1.20203Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTrending1;
